import React, { createContext, useContext } from 'react';
import type { ATContextProviderProps } from './types';

export type ATPageIndexCtxType = {
  pageIndex: number;
  setPageIndex: React.Dispatch<React.SetStateAction<number>>;
};

const ATPageIndexContext = createContext<ATPageIndexCtxType>({
  pageIndex: 1,
  setPageIndex: () => null,
});

export const useATPageIndex = (): ATPageIndexCtxType => {
  const ctx = useContext(ATPageIndexContext);
  if (ctx === null) {
    throw new Error('useATPageIndex must be used within a ATPageIndexProvider');
  }
  return ctx;
};

export const ATPageIndexContextProvider: React.FC<ATContextProviderProps> = ({
  children,
}) => {
  const [pageIndex, setPageIndex] = React.useState<number>(1);

  const pageIndexValue = React.useMemo(
    () => ({
      pageIndex,
      setPageIndex,
    }),
    [pageIndex],
  );

  return (
    <ATPageIndexContext.Provider value={pageIndexValue}>
      {children}
    </ATPageIndexContext.Provider>
  );
};
